var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Snowf',{attrs:{"amount":_vm.amount,"size":_vm.size,"speed":_vm.speed,"wind":_vm.wind,"opacity":_vm.opacity,"swing":_vm.swing,"image":null,"zIndex":null,"resize":true,"color":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }